module.exports = __webpack_public_path__ + "static/img/37.88a904e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/37.png
// module id = Zo5R
// module chunks = 0